import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import UpdateAddress from './UpdateAddress';
import UpdateGst from './UpdateGst';
import UpdateBankDetail from './UpdateBankDetail';
import UpdateCompanyDetails from './UpdateCompanyDetails';
import List from './Role/List.tsx';
import ProfileList from './Profile/List.tsx';
import OrganisationList from './Organisation/List.tsx';
import OrganizationForm from './Organisation/Onboarding/OrganisationForm.tsx';
import OrganisationOnboarding from './Organisation/Onboarding/index.tsx';
import OrganisationMapping from './Organisation/Mapping/List.tsx';
import CreateEditForm from './Organisation/CreateEdit.tsx';
import Permissions from './Profile/Permissions.tsx';
import ChangePasssword from './ChangePassword/ChangePassword.tsx';
import Account from './Account/index.tsx';
import OrganisationDashboardView from './ManageCampaign/OrganisationDashboardView.tsx';
import NewAccountForm from './ManageCampaign/NewAccountForm.tsx';
import AccountCreate from './ManageCampaign/AccountCreate.tsx';
import CreateProposal from './ManageCampaign/Campaign/CreateProposal.tsx';
import ProposalSummary from './ManageCampaign/ProposalSummary.tsx';
import ExecutionPlan from './ManageCampaign/ExecutionPlan.tsx';
import MyProfile from './MyProfile.tsx';
import RoleAssignment from './Role/RoleAssignment.tsx';
import UpdateGst1 from './UpdateGst1.tsx';
import UpdateAddress1 from './UpdateAddress1.tsx';
import LeadAnalyticsDashboard from '../LeadAnalytics/LeadAnalyticsDashboard.tsx';
import LicenseManagementPage from '../../features/license-management/pages/LicenseManagementPage.jsx';
import ProfileManagementRoutes from '../../features/profile-management/pages/ProfileManagementRoutes.jsx';
import UserManagementRoutes from '../../features/user-management/pages/UserManagementRoutes.jsx';
import OnboardingPage from '../../features/onboarding/pages/OnboardingPage';
import ProtectedRoute from '../Routes/ProtectedRoute.jsx';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import { ACCESS } from '../../constants/authz';
import { ROUTES } from '../../constants/routes';

const ManagementRoutes = () => {
  const actions = ConstantActions();
  return (
    <Routes>
      <Route
        exact
        path={`update-address/*`}
        element={
          <ProtectedRoute
            element={<UpdateAddress1 />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`update-gst/*`}
        element={
          <ProtectedRoute
            element={<UpdateGst1 />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`update-bank-details/*`}
        element={
          <ProtectedRoute
            element={<UpdateBankDetail />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`update-company-document/*`}
        element={
          <ProtectedRoute
            element={<UpdateCompanyDetails />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`role-list/*`}
        element={
          <ProtectedRoute
            element={<List />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`assign-role/*`}
        element={
          <ProtectedRoute
            element={<RoleAssignment />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`profile-list/*`}
        element={
          <ProtectedRoute
            element={<ProfileList />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`profile-permissions/:mode/*`}
        element={
          <ProtectedRoute
            element={<Permissions />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path="user-management/*"
        element={
          <ProtectedRoute
            element={<UserManagementRoutes />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.managementRoutes?.viewUserList,
            ])}
            access={ACCESS.USER_MANAGEMENT_VIEW}
          />
        }
      />

      <Route
        exact
        path="user-list/*"
        element={<Navigate to={ROUTES.MANAGEMENT.USER_MANAGEMENT} replace />}
      />

      <Route
        exact
        path="user/create/*"
        element={
          <Navigate to={`${ROUTES.MANAGEMENT.USER_MANAGEMENT}?drawer=create`} replace />
        }
      />

      <Route
        exact
        path="user/edit/*"
        element={<Navigate to={ROUTES.MANAGEMENT.USER_MANAGEMENT} replace />}
      />

      <Route
        exact
        path="user/:mode/*"
        element={<Navigate to={ROUTES.MANAGEMENT.USER_MANAGEMENT} replace />}
      />

      <Route
        exact
        path={`organisation-list/*`}
        element={
          <ProtectedRoute
            element={<OrganisationList />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`organisation/:mode/*`}
        element={
          <ProtectedRoute
            element={<CreateEditForm />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`organisation-onboarding/*`}
        element={
          <ProtectedRoute
            element={<OnboardingPage />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`organisation-onboard/*`}
        element={
          <ProtectedRoute
            element={<OrganisationOnboarding />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`organisation-mapping/*`}
        element={
          <ProtectedRoute
            element={<OrganisationMapping />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      {/* CHANGE PASSWORD SEPARATE */}

      <Route
        exact
        path={`change-password/*`}
        element={
          <ProtectedRoute
            element={<ChangePasssword />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.menuChangePassword,
            ])}
          />
        }
      />

      <Route
        exact
        path={`account/:mode/*`}
        element={
          <ProtectedRoute
            element={<Account />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.menuProfileAccount,
            ])}
          />
        }
      />

      <Route
        exact
        path={`manageCampaign/*`}
        element={
          <ProtectedRoute
            element={<OrganisationDashboardView />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.pagePermissions?.homePage,
            ])}
          />
        }
      />

      <Route
        exact
        path={`:mode/*`}
        element={
          <ProtectedRoute
            element={<AccountCreate />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />

      <Route
        exact
        path={`create-campaign/*`}
        element={
          <ProtectedRoute
            element={<CreateProposal />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.homePage?.createNewProposal,
            ])}
          />
        }
      />

      <Route
        exact
        path={`/proposal-summary/:id/*`}
        element={<ProtectedRoute element={<ProposalSummary />} permissionGranted={true} />}
      />

      <Route
        exact
        path={`opsExecutionPlan/*`}
        element={<ProtectedRoute element={<ExecutionPlan />} permissionGranted={true} />}
      />

      <Route
        exact
        path={`/profile/*`}
        element={<ProtectedRoute element={<MyProfile />} permissionGranted={true} />}
      />

      <Route
        exact
        path={`/lead-graph/*`}
        element={<ProtectedRoute element={<LeadAnalyticsDashboard />} permissionGranted={true} />}
      />

      <Route
        exact
        path="profile-management/*"
        element={
          <ProtectedRoute
            element={<ProfileManagementRoutes />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.managementRoutes?.manageProfile,
            ])}
            access={ACCESS.PROFILE_MANAGEMENT_VIEW}
          />
        }
      />

      <Route
        exact
        path="license-management/*"
        element={
          <ProtectedRoute
            element={<LicenseManagementPage />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.navBar?.viewManagement,
            ])}
          />
        }
      />
    </Routes>
  );
};

export default ManagementRoutes;
